/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ask_2Inputs */

const en_cp_ask_2 = /** @type {(inputs: Cp_Ask_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The rubric is used in grading — phase approvals carry weight`)
};

const id_cp_ask_2 = /** @type {(inputs: Cp_Ask_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rubrik dipakai dalam penilaian — persetujuan fase berbobot`)
};

/**
* | output |
* | --- |
* | "The rubric is used in grading — phase approvals carry weight" |
*
* @param {Cp_Ask_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ask_2 = /** @type {((inputs?: Cp_Ask_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ask_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ask_2(inputs)
	return en_cp_ask_2(inputs)
});